import React from 'react';
import { Typography } from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import MasterCardIcon from './svg/MasterCardIcon';
import AmexCardIcon from './svg/AmexCardIcon';
import DiscoverCardIcon from './svg/DiscoverCardIcon';
import UnionPayCardIcon from './svg/UnionPayCardIcon';
import DinnersClubIcon from './svg/DinersClubCardIcon';
import JCBCardIcon from './svg/JCBCardIcon';
import VisaCardIcon from './svg/VisaCardIcon';

interface IBrandCreditCardIconProps {
   brand?: string;
   fontSize?: string;
}

const BrandCreditCardIcon = ({ brand, fontSize }: IBrandCreditCardIconProps) => {
   const icons: Record<string, JSX.Element> = {
      visa: <VisaCardIcon />,
      mastercard: <MasterCardIcon />,
      amex: <AmexCardIcon />,
      discover: <DiscoverCardIcon />,
      diners: <DinnersClubIcon />,
      unionpay: <UnionPayCardIcon />,
      jcb: <JCBCardIcon />,
   };

   return (
      <>
         {brand && icons[brand] ? icons[brand] : <CreditCardIcon fontSize="medium" />}
         {brand && (
            <Typography marginLeft={1} fontSize={fontSize ? fontSize : '1rem'}>
               {brand.toUpperCase()}
            </Typography>
         )}
      </>
   );
};

export default BrandCreditCardIcon;
